<div class="add-form-config-page-dialog">
    <div class="popup-msg-content" ng-class="{alert:options.alert}">
        <h1 data-translate="addFormConfigPage.header"></h1>
        <c-auto-form config="$ctrl.autoFormConfig" class="autoform-no-margins"></c-auto-form>
    </div>
    <div class="popup-button-content">
        <span><button id="ok" class="popup-msg-button btn-primary" ng-click="$ctrl.ok()"><span data-translate="popup.ok"></span></button></span>
        <span><button id="cancel" class="popup-msg-button" ng-click="$ctrl.cancel()"><span data-translate="popup.cancel"></span></button></span>
    </div>
</div>